import React, {useEffect, useState} from 'react';
import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import MapComponent from "../../shared/map_component";
import {NumericFormat} from "react-number-format";
import {format} from "date-fns";
import {es} from "date-fns/locale";
import axios from "axios";

const RegistryReview = ({lot, movement}) => {
    const [debts, setDebts] = useState([]);
    const [historical, setHistorical] = useState([]);
    const [lastPayment, setLastPayment] = useState(null);

    const getCSRFToken = () => {
        const token = document.querySelector('meta[name="csrf-token"]');
        return token ? token.content : "";
    };

    useEffect(() => {
        async function fetchLotDetails() {
            try {
                const [debtsResponse, paymentResponse, historicalResponse] = await Promise.all([
                    fetch(`/lots/${lot.parcel_code}/yearly_debts.json`),
                    fetch(`/lots/${lot.parcel_code}/last_payment.json`),
                    fetch(`/lots/${lot.parcel_code}/history.json`),
                ]);

                if (debtsResponse.ok) {
                    const debtsData = await debtsResponse.json();
                    setDebts(debtsData);
                } else {
                    console.log("No se encontraron adeudos para este predio.");
                }

                if (paymentResponse.ok) {
                    const lastPaymentData = await paymentResponse.json();
                    setLastPayment(lastPaymentData);
                } else {
                    console.log("No se encontraron terrenos para este predio.");
                }

                if (historicalResponse.ok) {
                    const historyData = await historicalResponse.json();
                    setHistorical(historyData);
                } else {
                    console.log("No se encontró historico del predio.");
                }

            } catch (err) {
                console.error("Error al buscar el predio:", err);
            }
        }

        async function updateMovement() {
            try {
                const response = await axios.patch(`lots/${lot.parcel_code}.json`, {
                    reason_type_id: movement.id,
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        "X-CSRF-Token": getCSRFToken(),
                    }
                });
                if (response.status === 200) {
                    const url = `/lots/${lot.parcel_code}/print_movement.pdf`;
                    window.open(url, '_blank');
                } else {
                    setError('Error al actualizar movimiento. Verifica los datos.');
                }

            } catch (err) {
                console.error("Error al actualizar movimiento:", err);
            }
        }

        fetchLotDetails();
        updateMovement();
    }, []);

    const totalDebt = debts.reduce((acc, debt) => acc + debt.total, 0);
    const getUnit = lot.lot_location_type === 'URBANO' ? <>m<sup>2</sup></> : <>ha</>;

    return (
        <>
            {/* Información del predio */}
            <div className="flex-auto pb-2 pt-0">
                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                    Información del predio
                </h6>
                <div className="flex flex-col lg:flex-row gap-4 min-h-[350px]">
                    <div className="flex-grow border p-4 rounded-md w-full lg:w-1/2 overflow-x-hidden">
                        {lot && (
                            <>
                                <table className="w-full table-auto text-left">
                                    <tbody>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Tipo:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.lot_location_type}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Dirección:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.road_name}{lot.ext_num ? " #" + lot.ext_num : ""}, {lot.neighborhood_name},
                                                C.P. {lot.postal_code}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Referencias:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.address_references === null ? '' : lot.address_references}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Sup. Terreno:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.land_area.toFixed(2)} {getUnit}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Sup. Const:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.construction_area.toFixed(2)} m<sup>2</sup>
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr className='border-t'>
                                        <td className='pt-2'>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Propietario:
                                            </Typography>
                                        </td>
                                        <td className='pt-2'>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.name} {lot.parental_last_name} {lot.maternal_last_name}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Dirección:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.contributor_street}
                                                {lot.contributor_ext_num ? " #" + lot.contributor_ext_num : ""}
                                                {lot.contributor_neighborhood ? ', ' + lot.contributor_neighborhood : ''}
                                                {lot.contributor_postal_code ? ', C.P. ' + lot.contributor_postal_code : ''}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Teléfono:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.phone}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                RFC:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.rfc}
                                            </Typography>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant="small"
                                                color="blue-gray"
                                                className="font-bold"
                                            >
                                                Tipo de contribuyente:
                                            </Typography>
                                        </td>
                                        <td>
                                            <Typography
                                                variant="small"
                                                className="font-normal text-gray-600"
                                            >
                                                {lot.contributor_type === 'P' ? 'Persona física' : 'Persona moral'}
                                            </Typography>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </>
                        )}
                    </div>
                    <div className="flex-grow border rounded-md w-full lg:w-1/2 min-h-[350px]">
                        {lot.latitude && lot.longitude ? (
                            <MapComponent
                                parcel_code={lot.parcel_code}
                                latitude={lot.latitude}
                                longitude={lot.longitude}
                            />
                        ) : (
                            <MapComponent/>
                        )}
                    </div>
                </div>
                <div className="flex grid-cols-3 w-full mt-4 gap-4">
                    <Card className='w-full border' shadow={false}>
                        <CardHeader shadow={false} className='my-2'>
                            <Typography
                                variant="small"
                                color="gray"
                                className="font-medium text-center"
                            >
                                Valores
                            </Typography>
                        </CardHeader>
                        <CardBody className='pt-4'>
                            <div className='flex flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Calificación
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        <NumericFormat
                                            value={lot.qualification.toFixed(2)}
                                            displayType={'text'}
                                            prefix={'$'}
                                            allowLeadingZeros
                                            thousandSeparator=","
                                        />
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Tasa
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.rate.toFixed(2)}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Impuesto
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        <NumericFormat
                                            value={lot.tax.toFixed(2)}
                                            displayType={'text'}
                                            prefix={'$'}
                                            allowLeadingZeros
                                            thousandSeparator=","
                                        />
                                    </Typography>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
                <div className="flex grid-cols-3 w-full mt-6 gap-4">
                    <Card className='w-full border' shadow={false}>
                        <CardHeader shadow={false} className='my-2'>
                            <Typography
                                variant="small"
                                color="gray"
                                className="font-medium text-center"
                            >
                                R.P.P.
                            </Typography>
                        </CardHeader>
                        <CardBody className='pt-4'>
                            <div className='flex flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Insc.
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.inscription}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Folio
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.folio}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Libro
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.book}
                                    </Typography>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className='w-full border' shadow={false}>
                        <CardHeader shadow={false} className='my-2'>
                            <Typography
                                variant="small"
                                color="gray"
                                className="font-medium text-center"
                            >
                                Fecha de efecto
                            </Typography>
                        </CardHeader>
                        <CardBody className='pt-4'>
                            <div className='flex flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Bim.
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.effective_bimester}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Año
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lot.effective_year}
                                    </Typography>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                    <Card className='w-full border' shadow={false}>
                        <CardHeader shadow={false} className='my-2'>
                            <Typography
                                variant="small"
                                color="gray"
                                className="font-medium text-center"
                            >
                                Exento
                            </Typography>
                        </CardHeader>
                        <CardBody className='pt-4'>
                            <div className='flex flex-row gap-4 w-full text-center'>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Inicio
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        Bim {lot.start_exempt_bimester} - Año {lot.start_exempt_year}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Fin
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        Bim {lot.end_exempt_bimester} - Año {lot.end_exempt_year}
                                    </Typography>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>

            {/* Datos fiscales */}
            <div className="flex-auto pb-2 pt-0">
                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                    Datos Fiscales
                </h6>
                <div className="flex flex-col gap-4">
                    <Card className='w-full border border-blue-gray-50' shadow={false}>
                        <CardBody>
                            <div className='flex flex-row gap-4 w-full text-center mb-6'>
                                <div className='flex flex-col w-full p-4 rounded-md border bg-gray-50'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Último bimestre y año pagado
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lastPayment && (
                                            <>
                                                {lastPayment.bimester} Bim. del Año {lastPayment.year}
                                            </>
                                        )}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full p-4 rounded-md border bg-gray-50'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Último impuesto pagado
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lastPayment && (
                                            <NumericFormat
                                                value={Math.ceil(lastPayment.details_tax.toFixed(2))}
                                                displayType={'text'}
                                                prefix={'$'}
                                                allowLeadingZeros
                                                thousandSeparator=","
                                            />)}
                                    </Typography>
                                </div>
                                <div className='flex flex-col w-full p-4 rounded-md border bg-gray-50'>
                                    <Typography
                                        variant="small"
                                        className="text-[11px] font-medium uppercase text-blue-gray-400"
                                    >
                                        Fecha último pago
                                    </Typography>
                                    <Typography
                                        variant="paragraph"
                                        className="font-medium"
                                    >
                                        {lastPayment && format(lastPayment.created_at, 'PPP', {locale: es})}
                                    </Typography>
                                </div>
                            </div>
                            <Typography
                                variant="small"
                                className="text-[11px] font-medium uppercase mb-2 text-blue-gray-400"
                            >
                                Adeudos
                            </Typography>
                            <table className="w-full min-w-[640px] table-auto">
                                <thead>
                                <tr className='bg-gray-50'>
                                    {["Año", "Impuesto", "Imp. Univ.", "Recargos", "Total"].map(
                                        (el) => (
                                            <th
                                                key={el}
                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                            >
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    {el}
                                                </Typography>
                                            </th>
                                        )
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {(!debts || debts.length === 0) ? (
                                    <tr className="w-full">
                                        <td colSpan="100%" className="text-center py-3">
                                            <strong>El predio no tiene adeudos.</strong>
                                        </td>
                                    </tr>
                                ) : (debts.map((debt, index) => {
                                        const className = `py-3 px-5 ${
                                            index === debts.length - 1 ? "" : "border-b border-blue-gray-50"
                                        }`;
                                        return (
                                            <tr key={debt.year} className="hover:bg-gray-50 cursor-pointer">
                                                <td className={className}>{debt.year}</td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={debt.tax.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={debt.university_tax.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={debt.surcharge.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={debt.total.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                                </tbody>
                                <tfoot>
                                <tr className='border-t'>
                                    <td colSpan='4' className='py-3 px-5 text-right border-r'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Adeudo total
                                        </Typography>
                                    </td>
                                    <td className='py-3 px-5 bg-gray-50 border-b cursor-pointer'>
                                        <NumericFormat
                                            value={totalDebt.toFixed(2)}
                                            displayType={'text'}
                                            prefix={'$'}
                                            allowLeadingZeros
                                            thousandSeparator=","
                                        /></td>
                                </tr>
                                </tfoot>
                            </table>
                        </CardBody>
                    </Card>

                </div>
            </div>

            {/* Base Impuesto */}
            <div className="flex-auto pb-2 pt-0">
                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                    Base del Impuesto
                </h6>
                <div className="flex flex-col gap-4">
                    <div className="flex grid-cols-3 w-full gap-4">
                        <Card className='w-full border border-blue-gray-50' shadow={false}>
                            <CardBody>
                                <div className='flex flex-row gap-4 w-full text-center'>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Valor de Terreno
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            <NumericFormat
                                                value={lot.land_value.toFixed(2)}
                                                displayType={'text'}
                                                prefix={'$'}
                                                allowLeadingZeros
                                                thousandSeparator=","
                                            />
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Valor de construcción
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            <NumericFormat
                                                value={lot.construction_value.toFixed(2)}
                                                displayType={'text'}
                                                prefix={'$'}
                                                allowLeadingZeros
                                                thousandSeparator=","
                                            />
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Calificación
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            <NumericFormat
                                                value={lot.qualification.toFixed(2)}
                                                displayType={'text'}
                                                prefix={'$'}
                                                allowLeadingZeros
                                                thousandSeparator=","
                                            />
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Tasa
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            {lot.rate}
                                        </Typography>
                                    </div>
                                    <div className='flex flex-col w-full'>
                                        <Typography
                                            variant="small"
                                            className="text-[11px] font-medium uppercase text-blue-gray-400"
                                        >
                                            Impuesto
                                        </Typography>
                                        <Typography
                                            variant="paragraph"
                                            className="font-medium"
                                        >
                                            <NumericFormat
                                                value={lot.tax.toFixed(2)}
                                                displayType={'text'}
                                                prefix={'$'}
                                                allowLeadingZeros
                                                thousandSeparator=","
                                            />
                                        </Typography>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </div>
                </div>
            </div>

            {/* Historico */}
            <div className="flex-auto pb-2 pt-0">
                <h6 className="font-semibold uppercase text-gray-600 mt-8">
                    Historico
                </h6>
                <div className="flex flex-col gap-4">
                    <Card className='w-full border border-blue-gray-50' shadow={false}>
                        <CardBody className="max-w-[100%] overflow-x-scroll overflow-y-auto max-h-[560px]">
                            <table className="w-full min-w-max table-auto">
                                <thead>
                                <tr className='bg-gray-50'>
                                    {["Clave catastral", "Contribuyente", "Ult. clave catastral", "Inscripción", "Libro",
                                        "Folio", "Bim. Efecto", "Año Efecto", "Ini. Bim. Exep", "Ini. Año Exep.",
                                        "Fin Bim. Exep", "Fin Año Exep.", "Construcción", "Val. Const.", "Terreno",
                                        "Val. Terreno", "Ins. Esp.", "Val. Ins. Esp.", "Val. Catastral", "Tasa", "Impuesto",
                                        "Motivo", "Usuario", "Fecha"
                                    ].map(
                                        (el) => (
                                            <th
                                                key={el}
                                                className="border-b border-blue-gray-50 py-3 px-6 text-left"
                                            >
                                                <Typography
                                                    variant="small"
                                                    className="text-[11px] font-medium uppercase text-blue-gray-400"
                                                >
                                                    {el}
                                                </Typography>
                                            </th>
                                        )
                                    )}
                                </tr>
                                </thead>
                                <tbody>
                                {(!historical || historical.length === 0) ? (
                                    <tr className="w-full">
                                        <td colSpan="100%" className="text-center py-3">
                                            <strong>No se encontró historico del predio.</strong>
                                        </td>
                                    </tr>
                                ) : (historical.map((history, index) => {
                                        const className = `py-3 px-5 ${
                                            index === history.length - 1 ? "" : "border-b border-blue-gray-50"
                                        }`;
                                        return (
                                            <tr key={history.id} className="hover:bg-gray-50 cursor-pointer">
                                                <td className={className}>{history.parcel_code}</td>
                                                <td className={className}>{`${history.contributor_name} ${history.contributor_parental_last_name} ${history.contributor_maternal_last_name}`}</td>
                                                <td className={className}>{history.last_parcel_code}</td>
                                                <td className={className}>{history.inscription}</td>
                                                <td className={className}>{history.book}</td>
                                                <td className={className}>{history.folio}</td>
                                                <td className={className}>{history.effective_bimester}</td>
                                                <td className={className}>{history.effective_year}</td>
                                                <td className={className}>{history.start_exempt_bimester}</td>
                                                <td className={className}>{history.start_exempt_year}</td>
                                                <td className={className}>{history.end_exempt_bimester}</td>
                                                <td className={className}>{history.end_exempt_year}</td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.construction_area.toFixed(2)}
                                                        displayType={'text'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.construction_value.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.land_area.toFixed(2)}
                                                        displayType={'text'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.land_value.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    {history.special_facilities}
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.special_facilities_value.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.qualification.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    {history.rate.toFixed(0)}
                                                </td>
                                                <td className={className}>
                                                    <NumericFormat
                                                        value={history.tax.toFixed(2)}
                                                        displayType={'text'}
                                                        prefix={'$'}
                                                        allowLeadingZeros
                                                        thousandSeparator=","
                                                    />
                                                </td>
                                                <td className={className}>
                                                    {history.reason_type_id} - {history.description}
                                                </td>
                                                <td className={className}>
                                                    {history.user_last_update}
                                                </td>
                                                <td className={className}>
                                                    {format(history.created_at, 'PPP hh:mm', {locale: es})}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                                </tbody>
                            </table>
                        </CardBody>
                    </Card>

                </div>
            </div>
        </>
    )
};

export default RegistryReview;
